'use strict';

exports.__esModule = true;
exports.listTimes = listTimes;
exports.determineTimeSteps = determineTimeSteps;

var _dateFns = require('date-fns');

var MAX_ITERATIONS = 1000;

// TODO: refactor listTimes

/**
 * @typedef {{scale: string, step: number}} StepScale
 */

/**
 * Create a TimeStep object
 * @param {Date} yStart               Start time
 * @param {Date} yEnd                 End time
 * @param {StepScale} [stepScale] The desired scale and step size,
 *                      for example {scale: 'hour', step: 4}
 *                      Use the function determineTimeSteps to determine
 *                      a suitable scale based on the time interval.
 * @return {Date[]} Returns a an array with dates
 */
function listTimes(yStart, yEnd) {
  var stepScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : determineTimeSteps(yStart, yEnd, 20).major;


  // TODO: implement a week stepScale = { scale with steps of 7 days

  var times = [];
  var current = getFirst(yStart, stepScale);
  while (current.valueOf() < yEnd.valueOf() && times.length < MAX_ITERATIONS) {
    times.push(current);
    current = getNext(current, stepScale, yEnd);
  }
  times.push(current);

  return times;
}

/**
 * Determines and returns the next time (moment object) after given previous time (moment object) with given step
 * @param {Date} current
 * @param {StepScale} stepScale
 * @param {Date} end
 * @return {Date} Returns next date
 */
function getNext(current, stepScale, end) {
  var step = stepScale.step,
      scale = stepScale.scale;

  var next = current;

  switch (scale) {
    case 'millisecond':
      next = (0, _dateFns.addMilliseconds)(next, step);
      break;
    case 'second':
      next = (0, _dateFns.addSeconds)(next, step);
      break;
    case 'minute':
      next = (0, _dateFns.addMinutes)(next, step);
      break;
    case 'hour':
      next = (0, _dateFns.addHours)(next, step);
      if ((0, _dateFns.getMonth)(next) < 6) {
        // daylight savings end of March
        // in case of skipping an hour for daylight savings,
        // adjust the hour again (else you get: 0h 5h 9h ... instead of 0h 4h 8h ...)
        next = (0, _dateFns.subHours)(next, (0, _dateFns.getHours)(next) % step);
      } else {
        // daylight savings end of October
        if ((0, _dateFns.getHours)(next) % step !== 0) {
          next = (0, _dateFns.addHours)(next, step - (0, _dateFns.getHours)(next) % step);
        }
      }
      break;
    case 'day':
      next = (0, _dateFns.addDays)(next, step);
      break;
    case 'month':
      next = (0, _dateFns.addMonths)(next, step);
      break;
    case 'year':
      next = (0, _dateFns.addYears)(next, step);
      break;
    default:
      break;
  }

  if (step !== 1) {
    // round down to the correct step value
    switch (scale) {
      case 'millisecond':
        if ((0, _dateFns.getMilliseconds)(next) < step) next = (0, _dateFns.setMilliseconds)(next, 0);
        break;
      case 'second':
        if ((0, _dateFns.getSeconds)(next) < step) next = (0, _dateFns.setSeconds)(next, 0);
        break;
      case 'minute':
        if ((0, _dateFns.getMinutes)(next) < step) next = (0, _dateFns.setMinutes)(next, 0);
        break;
      case 'hour':
        if ((0, _dateFns.getHours)(next) < step) next = (0, _dateFns.setHours)(next, 0);
        break;
      case 'day':
        if ((0, _dateFns.getDate)(next) < step + 1) next = (0, _dateFns.setDate)(next, 1);
        break;
      case 'month':
        if ((0, _dateFns.getMonth)(next) < step) next = (0, _dateFns.setMonth)(next, 0);
        break;
      case 'year':
        break; // nothing to do for year
      default:
        break;
    }
  }

  // safety mechanism: if next time is still unchanged, move to the end
  if (next.valueOf() === current.valueOf()) {
    next = end;
  }

  return next;
}

/**
 * Set the range iterator to the start date.
 * @param {Date} start
 * @param {StepScale} stepScale
 */
function getFirst(start, stepScale) {
  var step = stepScale.step,
      scale = stepScale.scale;


  var first = start;

  // round to floor
  // IMPORTANT: we have no breaks in this switch! (this is no bug)
  // noinspection FallThroughInSwitchStatementJS
  /* eslint-disable */
  switch (scale) {
    case 'year':
      first = (0, _dateFns.setYear)(first, step * Math.floor((0, _dateFns.getYear)(first) / step));
      first = (0, _dateFns.setMonth)(first, 0);
    case 'month':
      first = (0, _dateFns.setDate)(first, 1);
    case 'day':
      first = (0, _dateFns.setHours)(first, 0);
    case 'hour':
      first = (0, _dateFns.setMinutes)(first, 0);
    case 'minute':
      first = (0, _dateFns.setSeconds)(first, 0);
    case 'second':
      first = (0, _dateFns.setMilliseconds)(first, 0);
    //case 'millisecond': // nothing to do for milliseconds
    default:
    // leave as is
  }
  /* eslint-enable */

  if (step !== 1) {
    // round down to the first minor value that is a multiple of the first step size
    switch (stepScale.scale) {
      case 'millisecond':
        first = (0, _dateFns.subMilliseconds)(first, (0, _dateFns.getMilliseconds)(first) % step);
        break;
      case 'second':
        first = (0, _dateFns.subSeconds)(first, (0, _dateFns.getSeconds)(first) % step);
        break;
      case 'minute':
        first = (0, _dateFns.subMinutes)(first, (0, _dateFns.getMinutes)(first) % step);
        break;
      case 'hour':
        first = (0, _dateFns.subHours)(first, (0, _dateFns.getHours)(first) % step);
        break;
      case 'day':
        first = (0, _dateFns.subDays)(first, ((0, _dateFns.getDate)(first) - 1) % step);
        break;
      case 'month':
        first = (0, _dateFns.subMonths)(first, (0, _dateFns.getMonth)(first) % step);
        break;
      case 'year':
        first = (0, _dateFns.subYears)(first, (0, _dateFns.getYear)(first) % step);
        break;
      default:
      // leave as is
    }
  }

  return first;
}

/**
 * Determine the scale and step value
 * @param {Date} yStart             Start time
 * @param {Date} yEnd               End time
 * @param {number} targetNumberOfSteps Desired number of steps
 * @returns {{ major: StepScale, minor: StepScale }}
 *      Returns an object with two types of steps: major and minor
 */
function determineTimeSteps(yStart, yEnd, targetNumberOfSteps) {
  // TODO: make minimumStep configurable, or depending on the window height
  var minimumStep = (yEnd - yStart) / targetNumberOfSteps;

  var stepMillisecond = 1;
  var stepSecond = stepMillisecond * 1000;
  var stepMinute = stepSecond * 60;
  var stepHour = stepMinute * 60;
  var stepDay = stepHour * 24;
  var stepMonth = stepDay * 30;
  var stepYear = stepMonth * 12;

  var stepScale = { major: { scale: 'hour', step: 1 }, minor: { scale: 'minute', step: 15 }

    // find the smallest value that is larger than the provided minimumStep
  };if (stepYear * 1000 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 1000 }, minor: { scale: 'year', step: 1 } };
  }
  if (stepYear * 500 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 500 }, minor: { scale: 'year', step: 50 } };
  }
  if (stepYear * 100 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 100 }, minor: { scale: 'year', step: 10 } };
  }
  if (stepYear * 50 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 50 }, minor: { scale: 'year', step: 10 } };
  }
  if (stepYear * 10 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 10 }, minor: { scale: 'year', step: 1 } };
  }
  if (stepYear * 5 > minimumStep) {
    stepScale = { major: { scale: 'year', step: 5 }, minor: { scale: 'year', step: 1 } };
  }
  if (stepYear > minimumStep) {
    stepScale = { major: { scale: 'year', step: 1 }, minor: { scale: 'month', step: 1 } };
  }
  if (stepMonth * 3 > minimumStep) {
    stepScale = { major: { scale: 'month', step: 3 }, minor: { scale: 'month', step: 1 } };
  }
  if (stepMonth > minimumStep) {
    stepScale = { major: { scale: 'month', step: 1 }, minor: { scale: 'month', step: 1 } };
  }
  if (stepMonth / 3 > minimumStep) {
    stepScale = { major: { scale: 'month', step: 1 }, minor: { scale: 'day', step: 1 } };
  }
  if (stepDay * 5 > minimumStep) {
    stepScale = { major: { scale: 'day', step: 5 }, minor: { scale: 'day', step: 1 } };
  }
  if (stepDay * 2 > minimumStep) {
    stepScale = { major: { scale: 'day', step: 2 }, minor: { scale: 'day', step: 1 } };
  }
  if (stepDay > minimumStep) {
    stepScale = { major: { scale: 'day', step: 1 }, minor: { scale: 'hour', step: 12 } };
  }
  if (stepHour * 4 >= minimumStep) {
    stepScale = { major: { scale: 'hour', step: 4 }, minor: { scale: 'hour', step: 1 } };
  }
  if (stepHour >= minimumStep) {
    stepScale = { major: { scale: 'hour', step: 1 }, minor: { scale: 'minute', step: 15 } };
  }
  if (stepMinute * 15 >= minimumStep) {
    stepScale = { major: { scale: 'minute', step: 15 }, minor: { scale: 'minute', step: 5 } };
  }
  if (stepMinute * 10 >= minimumStep) {
    stepScale = { major: { scale: 'minute', step: 10 }, minor: { scale: 'minute', step: 5 } };
  }
  if (stepMinute * 5 >= minimumStep) {
    stepScale = { major: { scale: 'minute', step: 5 }, minor: { scale: 'minute', step: 1 } };
  }
  if (stepMinute >= minimumStep) {
    stepScale = { major: { scale: 'minute', step: 1 }, minor: { scale: 'second', step: 15 } };
  }
  if (stepSecond * 15 >= minimumStep) {
    stepScale = { major: { scale: 'second', step: 15 }, minor: { scale: 'second', step: 5 } };
  }
  if (stepSecond * 10 >= minimumStep) {
    stepScale = { major: { scale: 'second', step: 10 }, minor: { scale: 'second', step: 5 } };
  }
  if (stepSecond * 5 >= minimumStep) {
    stepScale = { major: { scale: 'second', step: 5 }, minor: { scale: 'second', step: 1 } };
  }
  if (stepSecond >= minimumStep) {
    stepScale = { major: { scale: 'second', step: 1 }, minor: { scale: 'millisecond', step: 200 } };
  }
  if (stepMillisecond * 200 >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 200 }, minor: { scale: 'millisecond', step: 50 } };
  }
  if (stepMillisecond * 100 >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 100 }, minor: { scale: 'millisecond', step: 20 } };
  }
  if (stepMillisecond * 50 >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 50 }, minor: { scale: 'millisecond', step: 10 } };
  }
  if (stepMillisecond * 10 >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 10 }, minor: { scale: 'millisecond', step: 1 } };
  }
  if (stepMillisecond * 5 >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 5 }, minor: { scale: 'millisecond', step: 1 } };
  }
  if (stepMillisecond >= minimumStep) {
    stepScale = { major: { scale: 'millisecond', step: 1 }, minor: { scale: 'millisecond', step: 1 } };
  }

  return stepScale;
}